/**
 * Barre de progression du profil
 */
import React from 'react';
import './ProgressionBar.css';
import './ProgressionBar.css';

interface ProgressionBarProps {
  percentage: number;
  isComplete: boolean;
  visible: boolean;
}

const ProgressionBar: React.FC<ProgressionBarProps> = ({
  percentage,
  isComplete,
  visible
}) => {
  // Déterminer la couleur selon le pourcentage
  const getProgressColor = (): string => {
    if (isComplete) return '#22c55e'; // Vert
    if (percentage >= 75) return '#f59e0b'; // Orange
    if (percentage >= 50) return '#f97316'; // Orange foncé
    return '#ef4444'; // Rouge
  };

  // Déterminer le statut
  const getStatus = (): { text: string; className: string } => {
    if (visible) {
      return { text: 'Visible dans l\'annuaire', className: 'status-visible' };
    }
    return { text: 'Profil incomplet', className: 'status-incomplete' };
  };

  const status = getStatus();

  return (
    <div className="progression-bar-container">
      <div className="progression-info">
        <span className="progression-percentage">{percentage}%</span>
        <span className={`progression-status ${status.className}`}>
          {status.text}
        </span>
      </div>
      <div className="progression-track">
        <div
          className="progression-fill"
          style={{
            width: `${percentage}%`,
            backgroundColor: getProgressColor()
          }}
        />
      </div>
      <div className="progression-legend">
        <span>Remplissage du profil</span>
        {isComplete && !visible && (
          <span className="legend-info">✓ Complet</span>
        )}
        {visible && (
          <span className="legend-success">✓ Validé</span>
        )}
      </div>
    </div>
  );
};

export default ProgressionBar;
